import React, { Fragment, useContext } from 'react';
import PropTypes, { shape } from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';

import { Alert } from '@thd-olt-component-react/alert';
import { CheckNearByStore } from './CheckNearbyStore';
import { productShape } from '../../helpers/pod-fulfillment-utils';

export const NoStoreOption = ({
  storeMessage,
  enableNearbyStore,
  product,
  onCheckNearbyStoresClick
}) => {
  const { channel } = useContext(ExperienceContext);

  let renderNearbyStore = enableNearbyStore;
  if (channel !== 'mobile') {
    renderNearbyStore = false;
  }

  return (
    <>
      <Alert type="close" message={storeMessage} inline />
      {
        renderNearbyStore
        && (
          <div className="store__new-line">
            <CheckNearByStore
              product={product}
              onCheckNearbyStoresClick={onCheckNearbyStoresClick}
            />
          </div>
        )
      }
    </>
  );
};

NoStoreOption.propTypes = {
  enableNearbyStore: PropTypes.bool,
  onCheckNearbyStoresClick: PropTypes.func,
  product: shape({ productShape }),
  storeMessage: PropTypes.string,
};

NoStoreOption.defaultProps = {
  enableNearbyStore: true,
  onCheckNearbyStoresClick: null,
  product: null,
  storeMessage: 'Unavailable at your store',
};

NoStoreOption.displayName = 'NoStoreOption';
